import Konva from 'konva';
import GraphicBase from './base';

class GraphicBlockPoint extends GraphicBase {
  constructor(payload, stage) {
    super(payload, stage);

    this.canDraggable = true;
  }

  build() {
    const { data, id, stage } = this;

    const p = stage.pointDict[data[0]];
    this.ele = new Konva.Circle({
      id,
      name: id,
      type: this.type,
      pid: data[0],
      x: p.x,
      y: p.y,
      radius: 5,
      stroke: 'blue',
      fill: 'white',
      strokeWidth: 2,
    });

    this.ele.on('dragmove', (e) => {
      stage.pointDragHandler(e);
    });

    this.ele.on('click', (e) => {
      stage.pointClickHandler(e);
    });

    stage.tmpLayer.add(this.ele);
    this.layer = stage.tmpLayer;

    return this.ele;
  }
}

export default GraphicBlockPoint;
